import {usePhrase} from "../../i18n";
import XCircleIcon from "@heroicons/react/24/outline/XCircleIcon";
import Image from "next/image";
import PlayIcon from "@heroicons/react/16/solid/PlayIcon";
import React from "react";
import {YouTubeEmbed} from "@next/third-parties/google";

const ProductGalleryPopup = ({product, curMedia, handleSetCurMedia, galleryOpen, handleGalleryToggle, _t}) => {


    const t = usePhrase(_t);
    // get video id from https://www.youtube.com/v/VIDEO_ID?version=3&autohide=1&showinfo=0&controls=0&autoplay=1
    const getVideoId = (url) => {
        let video_id = url.split('/v/')[1];
        let ampersandPosition = video_id.indexOf('&');
        if (ampersandPosition !== -1) {
            video_id = video_id.substring(0, ampersandPosition);
        }
        return video_id;
    }

    return (<>
            <div
                className={`${!galleryOpen ? 'hidden' : ''} fixed top-0 left-0 w-full h-full  bg-[#333333aa] z-[30]`}
                onClick={handleGalleryToggle}></div>
            <div
                className={`${!galleryOpen ? 'hidden' : ''} fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-full h-full lg:w-[95%] lg:h-[95%]  flex justify-center items-center  z-[31]`}>
                <div className={`bg-white rounded  flex flex-col  w-full h-full `}>
                    <div className={`header border-b py-3 flex justify-between items-center px-4 `}>
                        <h3 className={`text-xl font-semibold`}>{t('Gallery')} {product?.name}</h3>
                        <div>
                            <XCircleIcon className={`cursor-pointer h-5 w-5`} onClick={handleGalleryToggle}/>
                        </div>
                    </div>
                    <div className={`flex flex-col lg:flex-row space-x-2 p-4 h-full`}>
                        <div className={`w-full lg:w-3/4 flex justify-center `}>
                            {curMedia && curMedia?.file && <>
                            {curMedia.type === 'video' ? <YouTubeEmbed videoid={getVideoId(curMedia.video)} height={'100%'} width={'720'} style={`max-w-auto`} /> :
                                <div
                                    className={'w-full h-full min-h-[300px] relative  after:bg-[#00000005] after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full cursor-pointer'}>


                                    <Image
                                        src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product' + curMedia.file}
                                        alt={product.name}
                                        fill={true}
                                        sizes="(max-width: 768px) 100vw,(max-width: 512px) 50vw,33vw"
                                        priority={false}
                                        className="w-full object-contain object-center"

                                    /></div>}
                                </>
                            }</div>
                        <div className={`w-full lg:w-1/4 flex-col px-0`}>
                            <div className={`hidden lg:block`}><h3>{product?.shortDescriptionSanitized}</h3></div>
                            <div className={`grid grid-cols-4 gap-3 py-3`}>
                                {product.media_gallery_entries && product.media_gallery_entries.map((entry, index) =>
                                    <div key={'product_media_' + index}
                                         className={`relative cursor-pointer border rounded after:bg-[#00000005] after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full flex items-center ${entry.file === curMedia?.file ? 'border-[#e7bb43]' : 'border-white '}`}
                                         onClick={(e) => handleSetCurMedia(entry)}>

                                        <Image
                                            src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product' + entry.file}
                                            alt={product.name}
                                            priority={false}
                                            width={80}
                                            height={80}
                                            sizes="80px"
                                            className="w-full object-cover object-center aspect-square rounded"/>
                                        {entry.media_type === 'external-video' && <div
                                            className={'absolute rounded top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center '}>
                                            <PlayIcon className={'w-8 h-8 fill-[#e7bb43]'}/>
                                        </div>}
                                    </div>)}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default ProductGalleryPopup;